import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";

export const adminsApi = createApi({
    reducerPath: 'adminsApi',
    tagTypes: ['admins'],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: build => ({
        getAdminOptions: build.query({
            query: ({ queryOptions, ...params }) => ({
                url: api.admin.getAdmins(),
                method: 'GET',
                params,
            }),
            serializeQueryArgs: ({ endpointName, queryArgs }) => {
                return [endpointName + 'Options', queryArgs?.location_id + 'Options']
            },
            merge: (currentCache, newItems, { arg }) => {
                if (arg.skip === 0) {
                    return newItems;
                }
                currentCache.push(...newItems.filter((newItem) => !currentCache.some((item) => item.id === newItem.id)))
            },
            forceRefetch: ({ currentArg, previousArg }) => {
                return currentArg !== previousArg;
            },
            providesTags: ['admins']
        }),
    })
})

export const { useGetAdminsQuery, useLazyGetAdminsQuery } = adminsApi
